import React, { useEffect } from "react";
import gsap from "gsap";
import SplitText from "../../utils/Split3.min.js";
import "./Hero.css";

const Hero = ({ className, setShowModal }) => {
  useEffect(() => {
    const split = new SplitText(".header-text", {
      type: "lines",
      linesClass: "lineChildren",
    });

    gsap.to(split.lines, {
      duration: 3,
      y: 0,
      opacity: 1,
      stagger: 0.2,
      ease: "power3",
    });
  }, []);
  return (
    <div
      className={"cursor-pointer content-hero " + className}
      data-scroll-section
      onClick={(e) => {
        e.preventDefault();
        setShowModal(true)
      }}
    >
      <div className="text-white">
      
        {/* <button className="bg-white hover:bg-blue-700 hover:text-white text-black font-bold py-2 px-4 btn-rsvp">
          RSVP NOW
        </button> */}
      
      </div>
    </div>
  );
};

export default Hero;
